import { cn } from "@/lib/utils";
import { Outlet, useNavigation } from "react-router-dom";

const WideLayout = () => {
  const { state } = useNavigation();

  return (
    <main
      className={cn(
        "my-4 grow md:mx-auto md:w-full lg:w-full xl:w-10/12",
        state === "loading" && "animate-pulse opacity-40",
      )}
    >
      <Outlet />
    </main>
  );
};

export { WideLayout };
